import { render } from "./MainLayoutV2.vue?vue&type=template&id=5635dd31"
import script from "./MainLayoutV2.vue?vue&type=script&lang=js"
export * from "./MainLayoutV2.vue?vue&type=script&lang=js"

import "@/assets/css/layoutstyles.css?vue&type=style&index=0&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__